// Copyright 2019 Drivetrain Hub LLC
// Handlers module index.
// https://vuejs.org/v2/guide/plugins.html
//
// Handlers are functions for handling data structures received by GraphQL API.
// Creates a single-source-of-truth when a handler function is used in multiple Vue components.
// Design pattern developed by C.Glinsky.

// Cannot type hint PluginObject without losing variable resolution.
// eslint-disable-next-line no-unused-vars
import { PluginFunction } from "vue";
import lib from "./modules/lib";
import model from "./modules/model";
import tool from "./modules/tool";
import gear from "./modules/gear";
import frame from "./modules/frame";
import eng from "./modules/eng";

/** @alias $handlers */
const Handlers = {lib, model, tool, gear, frame, eng};

/** @type {PluginFunction} */
Handlers.install = function(Vue) {
  Object.defineProperty(Vue.prototype, "$handlers", {
    get () { return Handlers }
  })
};

export default Handlers
